<template>
  <div
    v-if="flightStatusTexts[status]"
    :class="['status', flightStatusTexts[status].class]">
    {{ flightStatusTexts[status].status }}
  </div>
</template>

<script>
import { flightStatusTexts } from '../const'

export default {
  name: 'FlightStatus',
  props: {
    status: {
      type: String,
      default: false,
    },
  },
  data() {
    return {
      flightStatusTexts,
    }
  },
}
</script>

<style lang="sass" scoped>
.status
  padding: .2rem .8rem .3rem
  font-weight: 700
  font-size: 1.2rem
  line-height: 1.6rem
  border-radius: 4px
  color: #FFFFFF
  &.warning
    background: #FF7F37
  &.decline
    background: #ED2121
  &.accept
    background: $mainColor
</style>
